<template>
    <v-card class="mx-auto" max-width="600">
      <!-- Toolbar fixed on top for mobile -->
      <v-toolbar
        color="secondary"
        class="toolbar"
        :class="{ 'mobile-toolbar': $vuetify.display.smAndDown }"
      >
        <v-btn icon="mdi-menu" variant="text"></v-btn>
        <v-toolbar-title>My files</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon="mdi-magnify" variant="text"></v-btn>
        <v-btn icon="mdi-view-module" variant="text"></v-btn>
      </v-toolbar>

      <v-list lines="two">
        <v-list-subheader inset>Folders</v-list-subheader>

        <v-list-item
          v-for="folder in folders"
          :key="folder.title"
          :subtitle="folder.subtitle"
          :title="folder.title"
        >
          <template v-slot:prepend>
            <v-avatar color="grey-lighten-1">
              <v-icon color="white">mdi-folder</v-icon>
            </v-avatar>
          </template>

          <template v-slot:append>
            <v-btn
              color="grey-lighten-1"
              icon="mdi-information"
              variant="text"
            ></v-btn>
          </template>
        </v-list-item>

        <v-divider inset></v-divider>

        <v-list-subheader inset>Files</v-list-subheader>

        <v-list-item
          v-for="file in files"
          :key="file.title"
          :subtitle="file.subtitle"
          :title="file.title"
        >
          <template v-slot:prepend>
            <v-avatar :color="file.color">
              <v-icon color="white">{{ file.icon }}</v-icon>
            </v-avatar>
          </template>

          <template v-slot:append>
            <v-btn
              color="grey-lighten-1"
              icon="mdi-information"
              variant="text"
            ></v-btn>
          </template>
        </v-list-item>
      </v-list>
    </v-card>
</template>

<script>
export default {
  name: 'ListView',
  data() {
    return {
      folders: [
        { title: 'Photos', subtitle: 'Jan 9, 2014' },
        { title: 'Recipes', subtitle: 'Jan 17, 2014' },
        { title: 'Work', subtitle: 'Jan 28, 2014' }
      ],
      files: [
        {
          title: 'Vacation itinerary',
          subtitle: 'Jan 20, 2014',
          icon: 'mdi-file-document-outline',
          color: 'blue'
        },
        {
          title: 'Kitchen remodel',
          subtitle: 'Jan 10, 2014',
          icon: 'mdi-file-document-outline',
          color: 'green'
        }
      ]
    }
  }
}
</script>

<style scoped>

.toolbar {
  position: relative;
}

.mobile-toolbar {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: var(--v-theme-secondary);
}
</style>
